module.exports = __webpack_public_path__ + "img/ResourceDownload1.d85d205b.png";